<template>
  <div>
    <Button
      :size="15"
      color="#2da44e"
      colorText="#ffffff"
      tooltip="Agregar acuerdo clientes"
      icon="icon fas fa-plus"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      translate
      @click.native="openModal('modal')"
    />

    <ui-modal 
      ref="modal"
      title="Generar Acuerdo de Cliente Base según Filtros"
      @close="ActionSetZindexTablaModal(false)"
      size="large">
      
      <div class="container">
        <div class="row w-100 my-2">

          <div class="col-12">
            <ui-select
              class="w-100"
              has-search
              label="Cliente"
              :placeholder="placeholderClients"
              searchPlaceholder="Buscar"
              :options="clients"
              multiple
              :keys="{ value: 'id', label: 'name' }"
              v-model="formulario.clienteModel"
              @change="getContracts()"
              :disabled="selectedAllClients"
            />

            <div>
              <ui-switch 
                v-model="selectedAllClients"
                @change="selectAllClients">
                Seleccionar todos los Clientes
              </ui-switch>
            </div>

          </div>

        </div>
        <div class="row w-100 my-2">

          <div v-bind:class="formulario.navieraModel.length > 0 && formulario.navieraModel.some(nav => nav.name === 'UCC') ? 'col-4' : 'col-6'">

            <ui-select
              class="w-100"
              has-search
              label="Naviera"
              :options="navieras"
              multiple
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ value: 'id', label: 'name' }"
              @change="getContracts()"
              v-model="formulario.navieraModel"
            />

          </div>

          <div v-if="formulario.navieraModel.length > 0 && formulario.navieraModel.some(nav => nav.name === 'UCC')" class="col-4">

            <ui-select
              class="w-100"
              has-search
              label="Naviera Salida"
              :options="dataListaNavierasNoUCC"
              multiple
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ value: 'id', label: 'name' }"
              v-model="formulario.navieraSalidaModel"
            />

          </div>

          <div v-bind:class="formulario.navieraModel.length > 0 && formulario.navieraModel.some(nav => nav.name === 'UCC') ? 'col-4' : 'col-6'">

            <ui-select
              class="w-100"
              has-search
              label="Destino"
              placeholder="Seleccionar"
              :options="destinos"
              multiple
              searchPlaceholder="Buscar"
              :keys="{ value: 'id', label: 'name' }"
              v-model="formulario.destinoModel"
            />

          </div>

        </div>
        <div class="row w-100 my-2">

          <div class="col-4">

            <ui-select
              class="w-100"
              has-search
              label="POL"
              :options="dataListaPOL"
              multiple
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ value: 'id', label: 'name' }"
              v-model="formulario.polModel"
            />

          </div>

          <div class="col-4">

            <ui-select
              class="w-100"
              has-search
              label="POD"
              :options="dataListaPOD"
              multiple
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ value: 'id', label: 'name' }"
              v-model="formulario.podModel"
            />

          </div>

          <div class="col-4">

            <ui-select
              class="w-100"
              has-search
              label="Commodity"
              :options="selectCommodities"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ value: 'id', label: 'name' }"
              multiple
              v-model="formulario.productoModel"
            />

          </div>

        </div>
        <div class="row w-100 my-2">

          <div class="col-4">

            <ui-textbox
              class="w-100"
              type="number"
              :min="0"
              label="Margen"
              v-model="formulario.margenModel"
            />

          </div>

          <div class="col-4" style="top: -3px;">

            <div style="color: grey;"> Vigencia </div>

            <date-picker
              class="w-100"
              type="date"
              placeholder="Seleccionar"
              value-type="format"
              v-model="formulario.vigenciaModel"
            />

          </div>

          <div class="col-4">

            <ui-select
              class="w-100"
              has-search
              label="Tipo contenedor"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :options="contenedores"
              :keys="{ value: 'id', label: 'code' }"
              v-model="formulario.tipoContenedorModel"
            />

          </div>

        </div>
        <div class="row w-100 my-2">

          <div class="col-6">

            <ui-select
              class="w-100"
              has-search
              label="Tipo contrato"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :options="tipoContratos"
              :keys="{ value: 'id', label: 'name' }"
              @change="getContracts()"
              v-model="formulario.tipoContratoModel"
            />

          </div>

          <div class="col-6">

            <ui-select
              class="w-100"
              has-search
              label="Contrato"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :options="selectContract"
              :keys="{ value: 'id', label: 'name' }"
              v-model="formulario.contratoModel"
            />

          </div>

        </div>
        <div class="row w-100">

          <div class="col-12">

            <div class="d-flex justify-content-between">

              <button class="btn btn-default" @click="closeModal('modal')">
                Cerrar
              </button>

              <button
                class="btn btn-secondary"
                style="margin-right: 15px"
                @click="resetForm()">
                Limpiar
              </button>

              <button class="btn btn-outline-primary" @click="generar();" id="buttonRef">Generar</button>

            </div>

          </div>

        </div>
      </div>

    </ui-modal>
  </div>
</template>

<script>
// UI Modal
import UiModal from "keen-ui/src/UiModal";
import UiTextbox from "keen-ui/src/UiTextbox";
import UiSelect from "keen-ui/src/UiSelect";
import UiSwitch from "keen-ui/src/UiSwitch";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";

// Buttom
import Button from "../../../common/Button";

import { findTariffsLines, getAcuerdosClientesBase, getClients, getContratosPorNavieraYTipo } from "../../../../constants/lineas";

import { mapActions, mapState } from "vuex";

export default {
  props: [
  "data",
  "getListaAcuerdosClientesBase",
  "dataInicial",
  ],
  data() {
    return {
      formulario: {
        clienteModel: [],
        allClientsModel: [],
        navieraModel: [],
        navieraSalidaModel: [],
        destinoModel: [],
        podModel: [],
        polModel: [],
        productoModel: [],
        margenModel: "",
        vigenciaModel: "",
        tipoContenedorModel: [],
        tipoContratoModel: {
          id: 1,
          name : "Simple"
        },
        contratoModel: "",
      },
      selectedAllClients: false,
      placeholderClients: 'Seleccionar...',
      contracts: [],
      clients:[]
    };
  },
  components: {
    UiModal,
    UiTextbox,
    UiSelect,
    DatePicker,
    Button,
    UiSwitch
  },
  computed:{
    ...mapState([
      "contratos",
      "listaClientesUsuarioActual",
      "clientes",
      "navieras",
      "lineasSinContrato",
      "puertos",
      "destinos",
      "commodity",
      "tipoContratos",
      "contenedores",
      "estados",
      "pod",
      "filtros_pol",
      "filtros_pod"
    ]),
    ...mapState("lineas", [
      "selectCommodities",
      "selectAtmospheres",
      "selectContainers",
      "selectContract",
      "dataListaPOD",
      "dataListaPOL",
      "dataListaNavierasNoUCC"
    ])
  },
  methods: {
    ...mapActions("lineas", ["actionSetDataListarTarifasAcuerdosClientesBase", "actionSetSelectContract"]),
    ...mapActions(["ActionSetZindexTablaModal"]),

    async openModal(ref) {
      this.ActionSetZindexTablaModal(true);
      this.$refs[ref].open();
    },
    estadoButton(text, estado = true) {
      let buttonRef = document.querySelector("#buttonRef");
      buttonRef.innerHTML = text;
      buttonRef.disabled = estado;
    },
    async dataLista () {
      // const { filtro_contenedores, lista_prod_categories, lista_atmosferas } = await getListasAcuerdosBase();
      // this.filtroCommodity    = lista_prod_categories;
      // this.filtroAtmosferas   = lista_atmosferas;
      // this.filtroContenedores = filtro_contenedores.map((fc)=> ({
      //       id: fc.id,
      //       name : fc.code,
      //     }
      //   )
      // )
    },
    selectAllClients(){
      if(this.selectedAllClients){
        this.placeholderClients = 'Seleccionados Todos!';
        
        this.formulario.allClientsModel = this.listaClientesUsuarioActual.map( ({ id }) => id );
        console.log(this.formulario.clienteModel)
      } else {
        this.placeholderClients = 'Seleccionar...';
        this.formulario.allClientsModel = [];
      }
    },  
    resetForm(){
      this.formulario.navieraModel = [] ;
      this.formulario.navieraSalidaModel = [] ;
      this.formulario.vigenciaModel = "" ;
      this.formulario.contratoModel = [] ;
      this.formulario.destinoModel = [] ;
      this.formulario.podModel = [] ;
      this.formulario.polModel = [] ;
      this.formulario.margenModel = "" ;
      this.formulario.clienteModel = [] ;
      this.formulario.productoModel = [] ;
      this.formulario.tipoContenedorModel = [] ;
      this.formulario.tipoContratoModel = [] ;
    },
    async getContracts(){
      const data = await getContratosPorNavieraYTipo({
        type: this.formulario.tipoContratoModel.id
      });
      this.actionSetSelectContract(data);
    },
    async generar() {

      if (!this.selectedAllClients) {
        if (!this.formulario.clienteModel || this.formulario.clienteModel.length === 0) {
          return this.$vToastify.error(
            `Debe seleccionar Clientes`,
            "¡Error!"
          );
        }
      }

      // if( !this.formulario.navieraModel || this.formulario.navieraModel.length === 0 ){
      //   return this.$vToastify.error(
      //     `Debe seleccionar Navieras`,
      //     "¡Error!"
      //   );
      // }

      // if( !this.formulario.destinoModel || this.formulario.destinoModel.length === 0 ){
      //   return this.$vToastify.error(
      //     `Debe seleccionar Destinos`,
      //     "¡Error!"
      //   );
      // }

      if (!this.formulario.margenModel) {
        return this.$vToastify.error(
          `Debe agregar un margen`,
          "¡Error!"
        );
      }

      if (!this.formulario.vigenciaModel) {
        return this.$vToastify.error(
          `Debe agregar una Vigencia`,
          "¡Error!"
        );
      }

      this.$vToastify.loader("Generando...");

      this.estadoButton("Generando...");

      try {

        const form = {
          naviera_id: this.formulario.navieraModel.length > 0 ? this.formulario.navieraModel.map(n => n.id) : null,
          naviera_salida_id: this.formulario.navieraSalidaModel.length > 0 ? this.formulario.navieraSalidaModel.map(n => n.id) : null,
          vigencia: this.formulario.vigenciaModel,
          contract_id: this.formulario.contratoModel.id ?? null,
          destination_id: this.formulario.destinoModel.length > 0 ? this.formulario.destinoModel.map(d => d.id) : null,
          pod: this.formulario.podModel.length > 0 ? this.formulario.podModel.map(p => p.id) : null,
          pol: this.formulario.polModel.length > 0 ? this.formulario.polModel.map(p => p.id) : null,
          margin: +this.formulario.margenModel,
          client_id: this.selectedAllClients ? this.formulario.allClientsModel : (this.formulario.clienteModel.length > 0 ? this.formulario.clienteModel.map(c => c.id) : null),
          type: this.formulario.tipoContratoModel.id ?? null,
          products_category_id: this.formulario.productoModel.length > 0 ? this.formulario.productoModel.map(({ id }) => id) : null,
          container_id: this.formulario.tipoContenedorModel.id ?? null
        };

        const { data, status, message } = await findTariffsLines(form);

        if (!status && data.length === 0) {

          this.$vToastify.stopLoader();

          this.estadoButton("Generar", false);

          return this.$vToastify.warning(
            message,
            "¡Alerta!"
          );

        }

        const { data_table } = await getAcuerdosClientesBase();

        this.actionSetDataListarTarifasAcuerdosClientesBase(data_table);

        this.closeModal("modal");

        this.$vToastify.success(
          `Acuerdo de Clientes generados : ${data.length}`,
          "¡Realizado!"
        );

        this.resetForm();

        this.$vToastify.stopLoader();

        this.estadoButton("Generar", false);

      } catch (error) {

        console.log(error);

        this.$vToastify.stopLoader();

        this.estadoButton("Generar", false);

        return this.$vToastify.error(
          `No se encontraron concordancia de datos con acuerdos de lineas.`,
          "¡Error!"
        );

      }
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    async fetch(){
      const { data } = await getClients();
      this.clients = data;
    }
  },
  created() {

    this.fetch() ;

    setTimeout(() => {
      this.dataLista();
    }, 400);
    
  },
  // watch : {
  //   data: function (_new){
  //     this.getContracts();
  //   }
  // }
};
</script>

<style>
.color{
color: rgba(0, 0, 0, 0.75)
}

</style>
